export type ORDER_TRACKER_LOAD_ORDERS = 'ORDER_TRACKER/LOAD_ORDERS';
export const ORDER_TRACKER_LOAD_ORDERS: ORDER_TRACKER_LOAD_ORDERS = 'ORDER_TRACKER/LOAD_ORDERS';

export type ORDER_TRACKER_SORT_ORDERS = 'ORDER_TRACKER/SORT_ORDERS';
export const ORDER_TRACKER_SORT_ORDERS: ORDER_TRACKER_SORT_ORDERS = 'ORDER_TRACKER/SORT_ORDERS';

export type ORDER_TRACKER_LOAD_ORDER_DETAILS = 'ORDER_TRACKER/LOAD_ORDER_DETAILS';
export const ORDER_TRACKER_LOAD_ORDER_DETAILS: ORDER_TRACKER_LOAD_ORDER_DETAILS = 'ORDER_TRACKER/LOAD_ORDER_DETAILS';

export type ORDER_TRACKER_LOAD_ORDER_INFO = 'ORDER_TRACKER/LOAD_ORDER_INFO';
export const ORDER_TRACKER_LOAD_ORDER_INFO: ORDER_TRACKER_LOAD_ORDER_INFO = 'ORDER_TRACKER/LOAD_ORDER_INFO';

export type ORDER_TRACKER_LOAD_ORDER_PRODUCT_DETAILS = 'ORDER_TRACKER/LOAD_ORDER_PRODUCT_DETAILS';
export const ORDER_TRACKER_LOAD_ORDER_PRODUCT_DETAILS: ORDER_TRACKER_LOAD_ORDER_PRODUCT_DETAILS =
    'ORDER_TRACKER/LOAD_ORDER_PRODUCT_DETAILS';

export type ORDER_TRACKER_LOAD_ORDER_INFO_RESET = 'ORDER_TRACKER/LOAD_ORDER_INFO_RESET';
export const ORDER_TRACKER_LOAD_ORDER_INFO_RESET:
    ORDER_TRACKER_LOAD_ORDER_INFO_RESET = 'ORDER_TRACKER/LOAD_ORDER_INFO_RESET';

export type ORDER_TRACKER_UPDATE_SELECTED_PRODUCT = 'ORDER_TRACKER/UPDATE_SELECTED_PRODUCT';
export const ORDER_TRACKER_UPDATE_SELECTED_PRODUCT: ORDER_TRACKER_UPDATE_SELECTED_PRODUCT =
    'ORDER_TRACKER/UPDATE_SELECTED_PRODUCT';

export type ORDER_TRACKER_UPDATE_SELECTED_PRODUCT_TEMP = 'ORDER_TRACKER/UPDATE_SELECTED_PRODUCT_TEMP';
export const ORDER_TRACKER_UPDATE_SELECTED_PRODUCT_TEMP: ORDER_TRACKER_UPDATE_SELECTED_PRODUCT_TEMP =
    'ORDER_TRACKER/UPDATE_SELECTED_PRODUCT_TEMP';

export type ORDER_TRACKER_SEARCH_ORDER_DETAILS_SUMMARY = 'ORDER_TRACKER/SEARCH_ORDER_DETAILS_SUMMARY';
export const ORDER_TRACKER_SEARCH_ORDER_DETAILS_SUMMARY: ORDER_TRACKER_SEARCH_ORDER_DETAILS_SUMMARY =
    'ORDER_TRACKER/SEARCH_ORDER_DETAILS_SUMMARY';

export type ORDER_TRACKER_UPDATE_SEARCH_ORDER_DETAILS_SUMMARY = 'ORDER_TRACKER/UPDATE_SEARCH_ORDER_DETAILS_SUMMARY';
export const ORDER_TRACKER_UPDATE_SEARCH_ORDER_DETAILS_SUMMARY:
    ORDER_TRACKER_UPDATE_SEARCH_ORDER_DETAILS_SUMMARY = 'ORDER_TRACKER/UPDATE_SEARCH_ORDER_DETAILS_SUMMARY';

export type ORDER_TRACKER_UPDATE_SEARCH_ORDERS = 'ORDER_TRACKER/UPDATE_SEARCH_ORDERS';
export const ORDER_TRACKER_UPDATE_SEARCH_ORDERS: ORDER_TRACKER_UPDATE_SEARCH_ORDERS =
    'ORDER_TRACKER/UPDATE_SEARCH_ORDERS';

export type ORDER_TRACKER_LOAD_SUMMARY = 'ORDER_TRACKER/LOAD_SUMMARY';
export const ORDER_TRACKER_LOAD_SUMMARY: ORDER_TRACKER_LOAD_SUMMARY = 'ORDER_TRACKER/LOAD_SUMMARY';

export type ORDER_TRACKER_DOWNLOAD_CSV = 'ORDER_TRACKER_DOWNLOAD_CSV';
export const ORDER_TRACKER_DOWNLOAD_CSV: ORDER_TRACKER_DOWNLOAD_CSV = 'ORDER_TRACKER_DOWNLOAD_CSV';

export type ORDER_TRACKER_DETAIL_UPDATE_VIEW_BY = 'ORDER_TRACKER_DETAIL_UPDATE_VIEW_BY';
export const ORDER_TRACKER_DETAIL_UPDATE_VIEW_BY: ORDER_TRACKER_DETAIL_UPDATE_VIEW_BY =
    'ORDER_TRACKER_DETAIL_UPDATE_VIEW_BY';

export type ORDER_TRACKER_SELECT_COLUMNS = 'ORDER_TRACKER_SELECT_COLUMNS';
export const ORDER_TRACKER_SELECT_COLUMNS: ORDER_TRACKER_SELECT_COLUMNS =
    'ORDER_TRACKER_SELECT_COLUMNS';

export type ORDER_TRACKER_LOAD_PAGINATION = 'ORDER_TRACKER/LOAD_PAGINATION';
export const ORDER_TRACKER_LOAD_PAGINATION: ORDER_TRACKER_LOAD_PAGINATION =
    'ORDER_TRACKER/LOAD_PAGINATION';

export type ORDER_TRACKER_ORDER_EXPRESS_FLAG = 'ORDER_TRACKER_ORDER_EXPRESS_FLAG';
export const ORDER_TRACKER_ORDER_EXPRESS_FLAG: ORDER_TRACKER_ORDER_EXPRESS_FLAG =
    'ORDER_TRACKER_ORDER_EXPRESS_FLAG';

export type ORDER_TRACKER_ACTIVE_TAB = 'ORDER_TRACKER_ACTIVE_TAB';
export const ORDER_TRACKER_ACTIVE_TAB: ORDER_TRACKER_ACTIVE_TAB = 'ORDER_TRACKER_ACTIVE_TAB';

export type ORDER_TRACKER_UPDATE_ORDER_TABS = 'ORDER_TRACKER_UPDATE_ORDER_TABS';
export const ORDER_TRACKER_UPDATE_ORDER_TABS: ORDER_TRACKER_UPDATE_ORDER_TABS = 'ORDER_TRACKER_UPDATE_ORDER_TABS';

export type ORDER_TRACKER_UPDATE_ORDER_REFERENCE = 'ORDER_TRACKER_UPDATE_ORDER_REFERENCE';
export const ORDER_TRACKER_UPDATE_ORDER_REFERENCE: ORDER_TRACKER_UPDATE_ORDER_REFERENCE =
    'ORDER_TRACKER_UPDATE_ORDER_REFERENCE';

export type ORDER_TRACKER_DETAIL_UPDATE_ACCEPTANCE_STATUS = 'ORDER_TRACKER_DETAIL_UPDATE_ACCEPTANCE_STATUS';
export const ORDER_TRACKER_DETAIL_UPDATE_ACCEPTANCE_STATUS: ORDER_TRACKER_DETAIL_UPDATE_ACCEPTANCE_STATUS =
    'ORDER_TRACKER_DETAIL_UPDATE_ACCEPTANCE_STATUS';

export type ORDER_TRACKER_LOAD_APPOINTMENT_DATE = 'ORDER_TRACKER_LOAD_APPOINTMENT_DATE';
export const ORDER_TRACKER_LOAD_APPOINTMENT_DATE: ORDER_TRACKER_LOAD_APPOINTMENT_DATE =
    'ORDER_TRACKER_LOAD_APPOINTMENT_DATE';

export type ORDER_TRACKER_UPDATE_APPOINTMENT_DATE = 'ORDER_TRACKER_UPDATE_APPOINTMENT_DATE';
export const ORDER_TRACKER_UPDATE_APPOINTMENT_DATE: ORDER_TRACKER_UPDATE_APPOINTMENT_DATE =
    'ORDER_TRACKER_UPDATE_APPOINTMENT_DATE';
export type SERVICE_PERFORMANCE_PUT_SERVICE_REFERENCE_INT = 'SERVICE_PERFORMANCE_PUT_SERVICE_REFERENCE_INT';
export const SERVICE_PERFORMANCE_PUT_SERVICE_REFERENCE_INT: SERVICE_PERFORMANCE_PUT_SERVICE_REFERENCE_INT =
    'SERVICE_PERFORMANCE_PUT_SERVICE_REFERENCE_INT'

export type SERVICE_PERFORMANCE_PUT_SERVICE_REFERENCE_SERVICE_ID_INT =
    'SERVICE_PERFORMANCE_PUT_SERVICE_REFERENCE_SERVICE_ID_INT';
export const SERVICE_PERFORMANCE_PUT_SERVICE_REFERENCE_SERVICE_ID_INT:
    SERVICE_PERFORMANCE_PUT_SERVICE_REFERENCE_SERVICE_ID_INT =
    'SERVICE_PERFORMANCE_PUT_SERVICE_REFERENCE_SERVICE_ID_INT'

export type ORDER_TRACKER_LOAD_PRODUCT_LIST = 'ORDER_TRACKER_LOAD_PRODUCT_LIST'
export const ORDER_TRACKER_LOAD_PRODUCT_LIST: ORDER_TRACKER_LOAD_PRODUCT_LIST =
    'ORDER_TRACKER_LOAD_PRODUCT_LIST'

export type ORDER_TRACKER_LOAD_ORDERS_INT_V2 = 'ORDER_TRACKER/LOAD_ORDERS_INT_V2';
export const ORDER_TRACKER_LOAD_ORDERS_INT_V2: ORDER_TRACKER_LOAD_ORDERS_INT_V2 = 'ORDER_TRACKER/LOAD_ORDERS_INT_V2';

export type ORDER_TRACKER_INT_LIST_UPDATE = 'ORDER_TRACKER/LIST_FILTER_UPDATE';
export const ORDER_TRACKER_INT_LIST_UPDATE: ORDER_TRACKER_INT_LIST_UPDATE = 'ORDER_TRACKER/LIST_FILTER_UPDATE';

export type ORDER_TRACKER_UPDATE_SEARCH_ORDERS_INT_V2 = 'ORDER_TRACKER/UPDATE_SEARCH_ORDERS_INT_V2';
export const ORDER_TRACKER_UPDATE_SEARCH_ORDERS_INT_V2: ORDER_TRACKER_UPDATE_SEARCH_ORDERS_INT_V2 =
    'ORDER_TRACKER/UPDATE_SEARCH_ORDERS_INT_V2';

export type ORDER_TRACKER_UPDATE_ORDER_REFERENCE_LOCALLY  = 'ORDER_TRACKER/UPDATE_ORDER_REFERENCE_LOCALLY';
export const ORDER_TRACKER_UPDATE_ORDER_REFERENCE_LOCALLY: ORDER_TRACKER_UPDATE_ORDER_REFERENCE_LOCALLY =
    'ORDER_TRACKER/UPDATE_ORDER_REFERENCE_LOCALLY';

export type ORDER_TRACKER_DOWNLOAD_PRODUCT_LIST = 'ORDER_TRACKER_DOWNLOAD_PRODUCT_LIST'
export const ORDER_TRACKER_DOWNLOAD_PRODUCT_LIST: ORDER_TRACKER_DOWNLOAD_PRODUCT_LIST =
    'ORDER_TRACKER_DOWNLOAD_PRODUCT_LIST';

export type ORDER_TRACKER_PRODUCT_ORDERS_LIST = 'ORDER_TRACKER_PRODUCT_ORDERS_LIST'
export const ORDER_TRACKER_PRODUCT_ORDERS_LIST: ORDER_TRACKER_PRODUCT_ORDERS_LIST =
    'ORDER_TRACKER_PRODUCT_ORDERS_LIST';
